import { render, staticRenderFns } from "./BaseValidationEditTabRequirements.vue?vue&type=template&id=0f4be0c2&"
import script from "./BaseValidationEditTabRequirements.vue?vue&type=script&lang=js&"
export * from "./BaseValidationEditTabRequirements.vue?vue&type=script&lang=js&"
import style0 from "./BaseValidationEditTabRequirements.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports